import { render, staticRenderFns } from "./ProductNav.vue?vue&type=template&id=2ac11465&scoped=true"
import script from "./ProductNav.vue?vue&type=script&lang=ts"
export * from "./ProductNav.vue?vue&type=script&lang=ts"
import style0 from "./ProductNav.vue?vue&type=style&index=0&id=2ac11465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac11465",
  null
  
)

export default component.exports